import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import alertReducer from './alert';
import authReducer from './auth';
import uiReducer from './ui';
import chatReducer from './chat';
import langReducer from './lang';

const rootReducer = combineReducers({
  alert: alertReducer,
  auth: authReducer,
  ui: uiReducer,
  chat: chatReducer,
  lang: langReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['lang', 'auth'],
  blacklist: ['alert', 'ui'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
